module.exports = __webpack_public_path__ + "img/2025big3.7d5e1477.jpg";